import React from 'react';

import {
  RequestNumberColumn,
  OrderNumberColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
  StatusColumn,
} from './columns';
import { EnhancedReturnsBaseGrid } from './base-grid';

import status from './filters/options/status';

const columns = [
  RequestNumberColumn,
  OrderNumberColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
  StatusColumn,
];

const viewSpecificFilters = [status];

// TODO: https://auctane.atlassian.net/browse/SPD-20142 Column Configs per view/user?
export const EnhancedReturnsCompleted = () => {
  return <EnhancedReturnsBaseGrid columns={columns} viewSpecificFilters={viewSpecificFilters} />;
};
